import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { DirectEntryService } from '../../../direct-entry/shared/services/direct-entry/direct-entry.service';
import { navigateToHome } from '../../../../../core/resolver/shared/functions/navigate-to-home.function';

export const DirectEntryFormInitializerResolver = (
    route: ActivatedRouteSnapshot,
): Observable<boolean> => {
    const directEntryService = inject(DirectEntryService);

    const router = inject(Router);

    const applicationId = route?.paramMap.get('id');

    if (!applicationId) {
        console.log(
            'Tried to navigate to application page but Application ID is not defined.',
        );

        return navigateToHome(router);
    }

    /**
     * Sets the direct entry steps for the application (if the steps are not already set).
     * Once the steps are set, it will set the step validations for the application.
     */
    return directEntryService
        .getAndSetDirectEntryStepsWithValidations(applicationId)
        .pipe(
            map(() => true),
            catchError((error) => {
                console.error(
                    'Error in initializing direct entry form:',
                    error,
                );
                return navigateToHome(router);
            }),
        );
};
